const TextoPiePgina = ({ elementosweb, lang }) => {

    if (!elementosweb.pie_pagina || !elementosweb.pie_pagina[lang]) return null;

    return (
        <div className="px-3 pt-4 pb-2 text-center potblur bhh-piepagina">
            <p className="pt-4 mb-0 text-center border-top">{elementosweb.pie_pagina[lang]}</p>
        </div>
    );
};

export default TextoPiePgina;
